export default __webpack_public_path__ + "static/media/sportapp.48b98ac5.png";